import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

function AnimatedText(props) {
  const { text } = props;
  if (!text) {
    return null;
  }
  return (
    <svg className={styles.textAnimated}>
      <symbol id="s-text">
        <text textAnchor="left" x="0%" y="95%">{text}</text>
      </symbol>
      <g>
        <use xlinkHref="#s-text" className="text-copy" />
        <use xlinkHref="#s-text" className="text-copy" />
        <use xlinkHref="#s-text" className="text-copy" />
        <use xlinkHref="#s-text" className="text-copy" />
        <use xlinkHref="#s-text" className="text-copy" />
      </g>
    </svg>
  );
}


AnimatedText.propTypes = {
  text: PropTypes.string,
};

AnimatedText.defaultProps = {
  text: null,
};
export default AnimatedText;